// eslint-disable-next-line max-classes-per-file
import { sku, SKU } from '@src/app/model/sku';
import {
  Attachment,
  Configuration,
  ConfigurationPlacement,
  Id,
  ModulePlacement,
  XAttachmentPoint,
} from '@ess/jg-rule-executor';
import { GenerateManualPayload_manual_generateManualPayload } from '@src/app/generated/GenerateManualPayload';
import { SKUInfo } from '@src/app/model/sku-info';
import { Matrix4 } from 'three';

export class PortalManualConfiguration {
  configuration: Configuration;
  orderNumber: string;
  images: ConfigurationImages;
  skuPositions: Map<SKU, SKUInfo>;
  configurationName?: string;
  ean?: string;
  totalPurchasePrice?: number;

  constructor(
    configuration: Configuration,
    orderNumber: string,
    images: ConfigurationImages,
    skuPositions: Map<SKU, SKUInfo>,
    configurationName?: string,
    ean?: string,
    totalPurchasePrice?: number,
  ) {
    this.configuration = configuration;
    this.orderNumber = orderNumber;
    this.images = images;
    this.skuPositions = skuPositions;
    this.configurationName = configurationName;
    this.ean = ean;
    this.totalPurchasePrice = totalPurchasePrice;
  }

  static fromGql(input: GenerateManualPayload_manual_generateManualPayload): PortalManualConfiguration {
    if (input) {
      return new PortalManualConfiguration(
        new Configuration(
          input.configuration.id,
          input.configuration.name,
          input.configuration.email,
          input.configuration.code,
          new ConfigurationPlacement(
            input.configuration.configurationPlacement.placements.map(
              p => new ModulePlacement(
                p.id,
                p.variantId,
                new Matrix4().set(
                  p.transformation.r1.c1, p.transformation.r1.c2, p.transformation.r1.c3, p.transformation.r1.c4,
                  p.transformation.r2.c1, p.transformation.r2.c2, p.transformation.r2.c3, p.transformation.r2.c4,
                  p.transformation.r3.c1, p.transformation.r3.c2, p.transformation.r3.c3, p.transformation.r3.c4,
                  p.transformation.r4.c1, p.transformation.r4.c2, p.transformation.r4.c3, p.transformation.r4.c4
                ),
                p.xAttachments.values.reduce(
                  (coll, curr) => coll.set(curr.key, new Attachment(
                    curr.value.placementId, curr.value.yAttachmentId
                  )),
                  new Map<Id<XAttachmentPoint>, Attachment>()
                )
              )
            ),
            input.configuration.configurationPlacement.originPlacement,
            input.configuration.configurationPlacement.woodType
          ),
          input.configuration.isPreConfiguration,
          null,
          null,
          null,
          input.configuration.installationService
        ),
        input.orderNumber,
        input.images,
        input.skuPositions.values.reduce(
          (coll, curr) => coll.set(sku(curr.key), SKUInfo.fromGql(curr.value)),
          new Map<SKU, SKUInfo>()
        ),
        input.configurationName,
        input.ean,
        input.totalPurchasePrice,
      );
    }
  }
}

class ConfigurationImages {
  frontView: string;
  rightView: string;
  sideView: string;
  measurements: string;
  sides: string;
}
